import {connect} from 'react-redux';
import {VisualiseGel as Component} from './VisualiseGel';
import {
  showModal,
  visualizeGel
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    //solutions: state.notebook.protocolSection.scene.apparatus.solutions,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    visualizeGel: (data) => {
      dispatch(visualizeGel(data))
    }
  };
}

export const VisualiseGel = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
